import { useSearchParams } from 'react-router-dom';

import { Button } from 'antd';

import { FLOW_NAMES } from '@eduzz-registry-360/validators';

import { BlululupFlow } from '@/components/flows/BlululupFlow';
import { Error } from '@/components/flows/Error';
import { Loading } from '@/components/flows/Loading';
import Header from '@/components/globals/Header';
import { type FlowListName, Wizard } from '@/components/Wizard';
import { trpc } from '@/lib/trpc';
import useRegistryStore from '@/stores/registry';

const Blululululp = () => {
  const registry = useRegistryStore(state => state.registry);
  const [searchParams] = useSearchParams();
  const testSentryError = trpc.debug.testSentryError.useMutation();

  const flow = searchParams.get('flow');
  const flowIsValid = (FLOW_NAMES as readonly string[]).includes(flow ?? '');
  const defaultFlow = (flowIsValid ? flow : 'natural-person') as FlowListName;

  const handleTestApiError = async () => {
    try {
      await testSentryError.mutateAsync();
    } catch {
      throw Error();
    }
  };

  return (
    <>
      <Header />
      <section className='flex gap-4'>
        <Wizard defaultSelected={defaultFlow}>
          <Wizard.FlowList name='natural-person'>
            <BlululupFlow />
          </Wizard.FlowList>

          <Wizard.FlowList name='legal-entity'>
            <BlululupFlow />
          </Wizard.FlowList>

          <Wizard.FlowList name='loading'>
            <Loading />
          </Wizard.FlowList>

          <Wizard.FlowList name='error'>
            <Error />
          </Wizard.FlowList>
        </Wizard>

        <div>
          <pre>{JSON.stringify(registry, null, 2)}</pre>
        </div>

        <div className='fixed right-4 bottom-4 flex flex-col gap-2'>
          <Button
            id='btn-test-sentry-api'
            color='danger'
            variant='filled'
            loading={testSentryError.isPending}
            onClick={handleTestApiError}
          >
            {testSentryError.isPending ? 'Sending...' : 'Test Sentry'}
          </Button>
        </div>
      </section>
    </>
  );
};

export default Blululululp;
